const preparePath = () => {
  let path = location.pathname.split("/");
  path = path.filter(segment => segment !== "");
  return path.pop();
};

export const checkProgress = () => {
  const questions = [
    "new",
    "necklaces",
    "bracelets",
    "earrings",
    "rings",
    "trends",
    "ring_sizes",
    "finish",
    "signup"
  ];

  document.querySelectorAll("li.progress_step").forEach(li => li.classList.remove("filled"));

  const notFilled = document.querySelectorAll("li.progress_step:not(.filled)");
  [...notFilled].slice(
    0,
    questions.indexOf(preparePath()) + 1
  ).forEach(li => li.classList.add("filled"));
};


